import { render, staticRenderFns } from "./FreightTableClientSelect.vue?vue&type=template&id=6a31390d&scoped=true"
import script from "./FreightTableClientSelect.vue?vue&type=script&lang=js"
export * from "./FreightTableClientSelect.vue?vue&type=script&lang=js"
import style0 from "./FreightTableClientSelect.vue?vue&type=style&index=0&id=6a31390d&prod&scoped=true&lang=less"
import style1 from "./FreightTableClientSelect.vue?vue&type=style&index=1&id=6a31390d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a31390d",
  null
  
)

export default component.exports